import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  root: {
    backgroundColor: ({ color }) => color,
    height: ({ size }) => size,
    width: ({ size }) => size,
    outline: ({ color }) => (color === '#ffffff' ? '1px solid #000000' : 'none'),
  },
});

const SquareIcon = ({ size = 15, color = '#ffffff' }) => {
  const classes = useStyles({ size, color });

  return <div className={classes.root} />;
};

export default SquareIcon;
